module.exports = __webpack_public_path__ + "static/img/par10.4784a8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/par_game/par10.png
// module id = eten
// module chunks = 0